export const GenericMessage = 'El campo no contiene el formato correcto';
export const FieldRequired = 'El campo es requerido';
export const MinLength = 'Al menos {length} caracteres';
export const MaxLength = 'Máximo {length} caracteres';
export const EmailInvalid = 'El valor debe ser un correo electrónico';
export const OnlyLettersInvalid = 'Este campo no admite símbolos o números';
export const OnlyNumbersInvalid = 'Este campo solo admite números';
export const PhoneInvalid = 'Se requiere un número teléfonico de 10 dígitos';
export const LinkInvalid = 'El formato de la URL no es válido';
export const UniqueFile =
  'El nombre del archivo debe ser único. Ya existe un archivo con el mismo nombre';
export const PasswordInvalid =
  'Se espera: mínimo 8 caracteres, máximo 32, al menos: un número, una letra mayúscula, una letra minúscula y un carácter especial';
export const InvalidLogo =
  'Tipo de formato no válido. Solo se aceptan archivos .jpg. o .png para el logo.';
export const InvalidPhoto =
  'Tipo de formato no válido. Solo se aceptan archivos .jpg. o .png para la fotografía.';
export const InvalidDocument =
  'Tipo de formato no válido. Solo se aceptan archivos .pdf para documentos';
export const PhoneFormat = 'Ingrese un número de teléfono válido';
export const InvalidImagePlane =
  'Tipo de formato no válido. Solo se aceptan archivos .jpg, .png o .pdf';
export const InvalidImage =
  'Tipo de formato no válido. Solo se aceptan archivos .jpg. o .png';
export const InvalidPdf =
  'Tipo de formato no válido. Solo se aceptan archivos .pdf';
export const CompanyAssigned =
  'Esta empresa ya ha sido asignada a este tipo de propiedad. Intente con una diferente.';
export const UniqueFeature =
  'El nombre de la característica debe ser único. Ya existe una característica con este nombre.';
export const GuestAlreadyAdded =
  'Este invitado ya ha sido agregado a la visita';
export const MaxSize = 'El tamaño máximo permitido para archivos es de 10MB';
export const PasswordDontMatch = 'Las contraseñas no coinciden';
export const RequiredBrokerInAddGuest =
  'Debes seleccionar un  broker para agregar un invitado';
export const DocsLimit = 'Has llegado a límite de archivos por agregar';
export const LinkCopied = 'Link copiado correctamente';
export const LinkMatterportWarning =
  'Asegúrate de colocar un link válido para que los brokers no tengan problemas de visualización en sus visitas';
export const EndCall = '¿Estás seguro de terminar la llamada?';
export const Reconnecting = 'Se perdió la conexión, reconectando';
export const Disconnected =
  'No fue posible restablecer la conexión, para volver a intentar recarga la página';
export const Reconnected = 'Se ha restablecido la conexión de la llamada';
export const VideocallTimeout = 'Se ha terminado el tiempo de la llamada';
export const GuestsLimit = 'Has llegado a límite de invitados por agregar';
export const ScreenSharingError =
  'Es necesario aceptar los permisos del navegador para grabar la visita';
export const SuccessNote = 'Las notas se agregaron correctamente';
export const SuccessSignUp = 'Registro exitoso';
export const RequiredAnswersProperty =
  'Para continuar completa todos los campos solicitados.';
export const BrokerDosentWork =
  'El broker seleccionado no trabaja el día de la visita';
export const SelectHour = 'Debes seleccionar la hora de la cita';
